const DISTINCTIVE_TYPES: ReadonlySet<string> = new Set([
  "open",
  "delta",
  "close",
  "item",
]);

export function isDistinctivePart(frame: unknown): boolean {
  const t = (frame as { type?: unknown } | null)?.type;
  return typeof t === "string" && DISTINCTIVE_TYPES.has(t);
}

export function isContractBPart(frame: unknown, marked: boolean): boolean {
  const t = (frame as { type?: unknown } | null)?.type;
  if (typeof t !== "string") return false;
  if (DISTINCTIVE_TYPES.has(t)) return true;
  if (isSequencedDone(frame)) return true;
  return (t === "done" || t === "error") && marked;
}

export function isSequencedDone(frame: unknown): boolean {
  const f = frame as { type?: unknown; seq?: unknown } | null;
  return f?.type === "done" && typeof f?.seq === "number";
}
